import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button, type SxProps, type Theme } from "@mui/material";
import React from "react";

interface DropdownTriggerProps {
  children: React.ReactNode;
  isOpen: boolean;
  menuId: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  sx?: SxProps<Theme>;
  "aria-label"?: string;
}

const DropdownTrigger: React.FC<DropdownTriggerProps> = ({
  children,
  isOpen,
  menuId,
  onClick,
  sx,
  "aria-label": ariaLabel,
}) => {
  return (
    <Button
      aria-label={ariaLabel}
      aria-controls={isOpen ? menuId : undefined}
      aria-expanded={isOpen}
      aria-haspopup="menu"
      endIcon={
        <ArrowDropDownIcon
          aria-hidden="true"
          className="dropdown-trigger__arrow"
          sx={{
            color: "action.active",
            fontSize: 28,
          }}
        />
      }
      onClick={onClick}
      sx={[
        {
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          backgroundColor: isOpen ? "rgba(15, 23, 42, 0.06)" : "transparent",
          borderRadius: 1,
          color: "text.primary",
          height: 40,
          minWidth: 0,
          px: 1,
          py: 0.5,
          textTransform: "none",
          "&:hover": {
            backgroundColor: isOpen ? "rgba(15, 23, 42, 0.06)" : "rgba(15, 23, 42, 0.04)",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "rgba(15, 23, 42, 0.06)",
          },
          "& .MuiButton-endIcon": {
            marginInlineEnd: -0.5,
            marginInlineStart: 0,
          },
          "& > :first-child": {
            marginInlineEnd: 0.75,
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Button>
  );
};

export default DropdownTrigger;
